import { makeStyles } from '@mui/styles';
import Checkbox from 'apollo-react/components/Checkbox';
import TreeItem from 'apollo-react/components/TreeItem';
import TreeView from 'apollo-react/components/TreeView';
import React, { useEffect, useState } from 'react';

import { useTranslation } from '../../../custom-hooks/useTranslation';

const useStyles = makeStyles({
  treeView: {
    marginTop: 12,
    height: 'auto',
  },
});

const DocumentTree = ({
  repositoryName = '',
  documentRepositoryDetails,
  repositoryItems,
  onSelecteItem,
}) => {
  const translateString = useTranslation();
  const classes = useStyles();

  const [expanded, setExpanded] = useState([]);
  const [isOpenAll, setIsOpenAll] = useState(false);
  const [selected, setSelected] = useState('');

  const repositoryChildNodes = documentRepositoryDetails.ChildNodes || [];
  const defaultSelectedItem = repositoryChildNodes[0] ?? { NodeId: '' };
  const repositoryItemKey = `${repositoryName} / ${defaultSelectedItem.NodeId}`;

  const selectRepositoryItem = ({ NodeId, NodeText }) => {
    onSelecteItem({ repositoryName, NodeText, queryName: NodeText, nodeId: NodeId });
    setSelected(NodeId);
  };

  useEffect(() => {
    selectRepositoryItem(defaultSelectedItem);
    setExpanded([defaultSelectedItem.NodeId]);
    setIsOpenAll(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [repositoryItemKey]);

  const toggleExpandAll = (_, checked) => {
    setIsOpenAll(checked);

    if (!checked) {
      setExpanded([]);
    } else {
      setExpanded(
        Object.keys(repositoryItems).filter(
          (nodeId) => repositoryItems[nodeId].ChildNodes.length !== 0
        )
      );
    }
  };

  const renderTreeItems = (node) => {
    return (
      <TreeItem key={node.NodeId} nodeId={node.NodeId} label={translateString(node.NodeText)}>
        {node.ChildNodes.map((child) => renderTreeItems(child))}
      </TreeItem>
    );
  };

  return (
    <>
      <Checkbox
        label={translateString('Open All')}
        checked={isOpenAll}
        onChange={toggleExpandAll}
      />
      <div className={classes.treeView}>
        <TreeView
          onNodeSelect={(_, nodeId) => selectRepositoryItem(repositoryItems[nodeId])}
          onNodeToggle={(_, nodeIds) => setExpanded(nodeIds)}
          expanded={expanded}
          selected={selected}
        >
          {repositoryChildNodes.map(renderTreeItems)}
        </TreeView>
      </div>
    </>
  );
};

export default DocumentTree;
